import { useNavigate } from 'react-router-dom';

const DELIVERABLES = [
  { icon: 'ri-radar-line', title: 'AI Visibility Score', body: 'See if AI tools can find and recommend your business.' },
  { icon: 'ri-bar-chart-grouped-line', title: 'Competitive Analysis', body: 'See who shows up first and why.' },
  { icon: 'ri-file-search-line', title: 'GEO Gap Analysis', body: 'Find missing pages, missing schema, and weak copy.' },
  { icon: 'ri-funds-line', title: 'Lead Funnel Review', body: 'Find where leads drop off.' },
  { icon: 'ri-phone-find-line', title: 'Voice AI ROI Projection', body: 'See what missed calls may be costing you.' },
];

export default function FreeAudit() {
  const navigate = useNavigate();

  return (
    <section id="check" className="relative py-28 overflow-hidden bg-white">
      <div
        className="absolute inset-0 pointer-events-none opacity-90"
        style={{ background: 'radial-gradient(ellipse at 50% 0%, rgba(13,148,136,0.12), transparent 60%)' }}
      ></div>
      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="eyebrow reveal" style={{ color: '#EA580C', borderColor: 'rgba(249,115,22,0.3)' }}>
            <span className="bg-gradient-to-r from-[#F97316] to-[#FB923C] text-white rounded-full px-2.5 py-0.5 text-[10px] font-ui font-bold">
              LIMITED TIME
            </span>
            Limited Time Offer
          </div>
          <h2 className="mt-5 h-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] reveal">Free AI Check</h2>
          <p className="mt-6 text-slate-600 font-body font-light text-base md:text-lg reveal">
            We show what is hard to find, where leads leak, and what to fix first.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {DELIVERABLES.map((d) => (
            <div key={d.title} className="glass rounded-2xl p-6 reveal">
              <div className="icon-pill mb-4">
                <i className={`${d.icon} text-teal-500 text-lg`}></i>
              </div>
              <h4 className="h-display text-2xl leading-tight">{d.title}</h4>
              <p className="mt-3 text-slate-600 font-body font-light text-sm leading-relaxed">{d.body}</p>
            </div>
          ))}

          <div className="glass-teal rounded-2xl p-6 reveal flex flex-col justify-center">
            <div className="text-[11px] uppercase tracking-wider text-teal-600 font-body font-bold">
              Free When You Ask
            </div>
            <p className="mt-2 h-display text-2xl leading-tight">Get your check, free.</p>
            <button
              onClick={() => navigate('/audit')}
              className="mt-5 w-full inline-flex items-center justify-center gap-2 fdme-cta px-5 py-3 text-sm"
            >
              Get Your Free AI Check <i className="ri-arrow-right-up-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
